import React, {useEffect, useState, useRef} from 'react'
import { Row, Col } from "antd";
import "../../pages/Landing/Landing.css";
import styled from 'styled-components';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

export const MainSlogan = () => {
    const serviceRef = useRef(null)
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.5
            }
        );
    
        const serviceRefCurrent = serviceRef.current;
    
        if (serviceRefCurrent) {
            observer.observe(serviceRefCurrent);
        }
    
        return () => {
            if (serviceRefCurrent) {
                observer.unobserve(serviceRefCurrent);
            }
        };
    }, []);
    return (
        <Row
            className="mainSloganContainer"
        >
            <Col
                ref={serviceRef}
                className={`mainTextContainer ${isVisible ? 'fadeIn' : ''}`}
                
                span={24}
            >
                <StyledDiv>
                    <div
                        style={{
                            width: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: "15px"
                        }}
                    >
                        <p
                            className="mainText"
                        >
                            PROTECTING THE WORKER AND ENVIRONMENT
                        </p>
                    </div>

                    <div
                        style={{
                            width: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <p
                            className="subText"
                        >
                            A Behaviour Based <span
                                style={{
                                    color: "#F5A623",
                                }}
                            >Health,</span> <span
                            style={{
                                color: "#F5A623",
                            }}
                        >Safety</span> and <span
                        style={{
                            color: "#F5A623",
                        }}
                    >Environment</span> Program
                        </p>
                    </div>
                </StyledDiv>
            </Col>
        </Row>
    )
}
